<template>
  <div id="wrap">
    <Header/>
    <Scroll/>
    <AlertPopup v-if="showAlertPopup" @close="handleClosePopup" />
    <div class="hp_mainSlider"> <!-- 메인 롤링 배너 -->
      <div class="hp_mainSliderInner">
        <swiper :options="statusData.rollingSwiperOptions"
          class="hp_mainSlider_swiperWrap">
            <swiper-slide
              v-for="item in statusData.rollingBannerData"
              :key="item.rolling_banner_ID">
              <a :href="item.rolling_banner_link">
                <p class="hp_mainslideImgBox mainslide_mobileImg">
                  <img
                    :src="item.rolling_banner_image_mobile"
                    :alt="item.rolling_banner_name"
                  />
                </p>
                <p class="hp_mainslideImgBox mainslide_pcImg">
                  <img
                    :src="item.rolling_banner_image"
                    :alt="item.rolling_banner_name"
                  />
                </p>
              </a>
            </swiper-slide>
            <!-- <p class="rolling_swiper_prev" slot="button-prev"/>
            <p class="rolling_swiper_next" slot="button-next"/> -->
            <!-- <p class="swiper-pagination"></p> -->
        </swiper>
      </div>
    </div>

    <div class="hp_scSliderWrap">
      <div class="hp_mainSingleTitBox">
        <p>(주)행복을주는사람들 <span>추천여행</span></p>
        <p>가이드가 추천하는 테마가 있는 여행상품모음을 소개합니다.</p>
      </div>
      <div class="hp_scSlider_Slieder"> <!-- 행주사 추천여행 롤링 배너 -->
        <ul>
          <li
              v-for="item in statusData.recommendBannerData"
              :key="item.recommend_banner_ID">
              <a :href="item.recommend_banner_link">
                <p class="hp_scSlider_SliederImgBox">
                  <img
                    :src="item.recommend_banner_main_image"
                    :alt="item.recommend_banner_title"
                  />
                </p>
              </a>
            </li>
        </ul>
      </div>
    </div>

    <div class="hp_thSwiperWrap">
      <div class="hp_mainSingleTitBox">
        <p><span>이달의</span>추천여행</p>
        <p>이번 시즌 (주)행복을주는사람들 추천하는 꼭! 가볼만한 여행상품들을 추천합니다.</p>
      </div>
      <div class="hp_thSwiper_Slieder"> <!-- 이달의 추천여행 -->
        <swiper :options="statusData.recommendSwiperOption">
          <swiper-slide
            v-for="item in statusData.recommendMonthBannerData"
            :key="item.recommend_month_banner_ID">
            <a class="hp_thSwiper_SliederBox" :href="'/TravelProductDetail?travelProductID=' + item.travel_product_ID">
              <p class="hp_thSwiper_SliederImgBox">
                <img :src="item.travel_product_img1" :alt="item.travel_product_name" />
                <span>{{item.travel_type_name}}</span>
              </p>
              <div class="hp_miniSlider_infoBox"><!-- travel-banner-slider -->
                <p class="hp_miniSlider_infoBox_tit">{{ item.travel_product_name }}</p>
                <div class="hp_miniSlider_infoBox_flex">
                  <p class="hp_miniSlider_infoBox_price">{{ Number(item.schedule_price_min).toLocaleString() }}<span>원~</span></p>
                </div>
              </div>
              <div style="margin-top:10px;">
                <span class="hp_thSwiper_SliederTag" v-for="tag in JSON.parse(item.travel_product_tag)" :key="tag">{{ tag }}</span>
              </div>
            </a>
          </swiper-slide>
          <!-- 좌우버튼 안보이게 주석처리
          <div class="recommend_swiper_prev" slot="button-prev"/>
          <div class="recommend_swiper_next" slot="button-next"/>
          -->
        </swiper>
      </div>
    </div>

    <div class="hp_mainMiniBanner"> <!-- 자유배너 -->
      <a :href="statusData.fixBannerLink1">
        <p>
          <img :src="statusData.fixBannerImage1" :alt="statusData.fixBannerTitle1">
        </p>
      </a>
    </div>

    <div class="hp_miniSliderWrap"
     v-for="type in statusData.travelTypeBannerData" :key="type.id">
      <div class="hp_miniSliderTitBox">
        <p>{{ type.title }}</p>
        <p><a :href="'/TravelProduct?travelTypeDivision=' + type.id">더보기</a></p>
      </div>
      <swiper :options="type.swiperOption" class="hp_miniSlider_SliederBoxBody"> <!-- 미니 롤링 배너 -->
        <swiper-slide v-for="item in type.bannerData" :key="item.travel_product_ID">
          <a class="hp_miniSlider_SliederBox" :href="'/TravelProductDetail?travelProductID=' + item.travel_product_ID">
            <p class="hp_miniSlider_SliederImgBox">
              <img :src="item.travel_product_img1" :alt="item.travel_product_name" />
            </p>
            <div class="hp_miniSlider_infoBox"><!-- travel-banner-slider -->
              <div style="margin:10px 0;">
                <span class="hp_miniSlider_tag" v-for="tag in JSON.parse(item.travel_product_tag)" :key="tag">{{ tag }}</span>
              </div>
              <p class="hp_miniSlider_infoBox_tit">{{ item.travel_product_name }}</p>
              <div class="hp_miniSlider_infoBox_flex">
                <p class="hp_miniSlider_infoBox_type">{{item.travel_type_name}}</p>
                <p class="hp_miniSlider_infoBox_price">{{ Number(item.schedule_price_min).toLocaleString() }}<span>원~</span></p>
              </div>
            </div>
          </a>
        </swiper-slide>
        <!-- 좌우버튼 안보이게 주석처리
          <div :class="type.typeKey + '_swiper_prev'" slot="button-prev"/>
          <div :class="type.typeKey + '_swiper_next'" slot="button-next"/>
          -->
      </swiper>
    </div>

    <Footer/>

  </div>
</template>

<script>
/* eslint-disable camelcase */
import Vue, { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import AlertPopup from '../Section/AlertPopup.vue'
import {
  get_rolling_banner_use,
  get_recommend_banner_main_use,
  get_recommend_month_banner_main_use,
  get_travel_product_use_main,
  base_url_export,
  get_fix_banner_all
} from '../../ETC/Axios.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'Main',
  components: {
    Header,
    Footer,
    Scroll,
    AlertPopup,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  setup () {
    const showAlertPopup = ref(true)
    return {
      showAlertPopup,
      statusData: ref({
        baseUrlExport: base_url_export,
        rollingBannerData: [],
        recommendBannerData: [],
        recommendMonthBannerData: [],
        fixBannerTitle1: '',
        fixBannerLink1: '',
        fixBannerImage1: '',
        travelTypeBannerData: [],
        rollingSwiperOptions: { // 메인 롤링 배너
          autoplay: {
            delay: 2400,
            disableOnInteraction: false
          },
          speed: 1400,
          loop: true, /* 무한 루프 */
          loopAdditionalSlides: 12, /* 무한 루프 첫번째 순서를 위해 슬라드 수 임의로 10으로 작성 */
          preloadImages: true,
          pagination: {
            el: '.swiper-pagination'
          },
          navigation: {
            prevEl: '.rolling_swiper_prev',
            nextEl: '.rolling_swiper_next'
          },
          breakpoints: {
            360: {
              centeredSlides: true,
              slidesPerView: 1.14, /* 보여지는 순서, 0이 기본이고 0으로 해야 관리자1번째보임 */
              spaceBetween: 11 /* 이미지 사이간격 */
            },
            1150: {
              centeredSlides: false,
              slidesPerView: 1,
              spaceBetween: 30
            }
          }
        },
        recommendSwiperOption: { // 이달의 추천여행 롤링 배너
          autoplay: {
            delay: 2600,
            disableOnInteraction: false
          },
          speed: 600,
          loop: true,
          loopAdditionalSlides: 1,
          breakpoints: {
            360: {
              slidesPerView: 1.6
            },
            700: {
              slidesPerView: 2.65
            },
            1150: {
              slidesPerView: 3,
              width: 1185
            }
          },
          navigation: {
            prevEl: '.recommend_swiper_prev',
            nextEl: '.recommend_swiper_next'
          }
        },
        travelTypeSwiperOptions: { // 미니 롤링 배너
          breakpoints: {
            360: {
              slidesPerView: 2.2
            },
            700: {
              slidesPerView: 3.2
            },
            1150: {
              slidesPerView: 4,
              width: 1174,
              allowTouchMove: false
            }
          },
          navigation: {}
        }
      })
    }
  },
  methods: {
    handleClosePopup (doNotShowToday) {
      this.showAlertPopup = false

      if (doNotShowToday) {
        localStorage.setItem('hidePopupToday', new Date().toDateString())
      }
    },
    checkPopupVisibility () {
      const today = new Date().toDateString()
      const hidePopupToday = localStorage.getItem('hidePopupToday')

      if (hidePopupToday === today) {
        this.showAlertPopup = false
      } else {
        this.showAlertPopup = true
      }
    },
    initializeTravelTypes () {
      const types = [
        { id: 1, title: '국악와인열차', typeKey: 'type1' },
        { id: 2, title: '팔도장터열차', typeKey: 'type2' },
        { id: 3, title: '일반기차여행', typeKey: 'type3' },
        /* { id: 4, title: '버스/자유여행', typeKey: 'type4' }, 이거는 지금당장 사용안해서 나중에 추가할 예정 */
        { id: 5, title: '섬/제주/해외여행', typeKey: 'type5' }
      ]
      types.forEach(type => {
        this.statusData.travelTypeBannerData.push({
          ...type,
          swiperOption: {...this.statusData.travelTypeSwiperOptions,
            navigation: {
              prevEl: `.${type.typeKey}_swiper_prev`,
              nextEl: `.${type.typeKey}_swiper_next`
            }}
        })
      })
    },
    loadBannerData () {
      get_rolling_banner_use().then(result_data => {
        this.statusData.rollingBannerData = result_data
      })
      get_recommend_banner_main_use().then(result_data => {
        this.statusData.recommendBannerData = result_data
      })
      get_recommend_month_banner_main_use().then(result_data => {
        this.statusData.recommendMonthBannerData = result_data
      })
      get_travel_product_use_main().then(result_data => {
        this.statusData.travelTypeBannerData.forEach((type, index) => {
          Vue.set(this.statusData.travelTypeBannerData, index, {
            ...type,
            bannerData: result_data[type.typeKey + 'Result']
          })
        })
      })
      get_fix_banner_all().then((result) => {
        result.forEach(element => {
          if (element.fix_banner_division === 1) {
            this.statusData.fixBannerTitle1 = element.fix_banner_title
            this.statusData.fixBannerLink1 = element.fix_banner_link
            this.statusData.fixBannerImage1 = element.fix_banner_image
          }
        })
      })
    }
  },
  mounted () {
    this.initializeTravelTypes()
    this.loadBannerData()
    this.checkPopupVisibility()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Main/Main.vue